var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeminiAi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#E4E4E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 17.02C24.4052 17.1792 21.9583 18.2818 20.12 20.12C18.2818 21.9583 17.1792 24.4052 17.02 27H16.98C16.821 24.4051 15.7185 21.958 13.8803 20.1197C12.042 18.2815 9.59485 17.179 7 17.02L7 16.98C9.59485 16.821 12.042 15.7185 13.8803 13.8803C15.7185 12.042 16.821 9.59485 16.98 7L17.02 7C17.1792 9.59476 18.2818 12.0417 20.12 13.88C21.9583 15.7182 24.4052 16.8208 27 16.98V17.02Z",
    fill: "url(#paint0_radial_6609_20678)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6609_20678",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.985 15.1287) rotate(18.6832) scale(21.2875 170.526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#9168C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#5684D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#1BA1E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeminiAi);
export default __webpack_public_path__ + "static/media/GeminiAI.b32c6bd480f8925acdb6d333b98221da.svg";
export { ForwardRef as ReactComponent };